import { ReactElement } from "react";

import { HStack, Text, useBreakpointValue } from "@chakra-ui/react";

import { ESIGN } from "util/featureFlags";
import useFeatureFlag from "hooks/useFeatureFlag";
import usePermission from "hooks/usePermission";
import ConditionCheck from "components/ConditionCheck";
import ContractStat from "./ContractStat";

const ContractStatus = ({
  textStyle,
  fontWeight = "black",
  size,
  status = "",
  isUnsigned = false,
  isLoaded = true,
  isError = false,
  showLabel = true,
}: {
  textStyle: Record<string, string> | string[];
  fontWeight?: string;
  size?: string;
  status?: string;
  isUnsigned?: boolean;
  isLoaded?: boolean;
  showLabel?: boolean;
  isError?: boolean;
}): ReactElement => {
  const hasEsignFeatureFlag = useFeatureFlag(ESIGN.SIGN);
  const hasEsignPermission = usePermission(ESIGN.SIGN);

  const statusTextStyle = useBreakpointValue(textStyle);

  return (
    <ContractStat
      label={showLabel ? "Status" : undefined}
      size={size}
      isLoaded={isLoaded}
      isError={isError}
    >
      <HStack
        spacing={1}
        minWidth="200px"
        textStyle={statusTextStyle}
        fontWeight={fontWeight}
      >
        <Text>{status}</Text>
        <ConditionCheck
          conditions={[isUnsigned, hasEsignFeatureFlag, hasEsignPermission]}
        >
          <Text>-</Text>
          <Text color="warningRed">Available to Sign</Text>
        </ConditionCheck>
      </HStack>
    </ContractStat>
  );
};

export default ContractStatus;
